var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "问卷发布记录",
        visible: _vm.historyDialogVisible,
        "destroy-on-close": "",
        width: "750px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.historyDialogVisible = $event
        },
      },
    },
    [
      _vm.historyData.length > 0
        ? [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.historyData, "max-height": "420" },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    label: "发布记录",
                    "header-align": "center",
                    width: "110",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " + _vm._s(" 第 " + row.no + " 次发布") + " "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1639706049
                  ),
                }),
                _c("el-table-column", {
                  attrs: { label: "发布时间", "header-align": "center" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  row.inUse
                                    ? row.createTime + " 至今 "
                                    : row.createTime + " 至 " + row.updateTime
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2931705951
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "publisher",
                    label: "操作人",
                    align: "center",
                    width: "220",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "address",
                    label: "操作按钮",
                    width: "100",
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.toHistoryDetail(scope)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3135803123
                  ),
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.historyData.length == 0
        ? _c(
            "div",
            [
              _c("el-empty", {
                attrs: { slot: "empty", description: "当前问卷发布记录为空" },
                slot: "empty",
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  _vm.historyDialogVisible = false
                },
              },
            },
            [_vm._v("关 闭")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }